export enum ErrorVisualMode {
  Plain = 'plain',
  TechnicalError = 'tecnical-error',
  Sad = 'sad',
}
